export default __webpack_public_path__ + "static/1.1_IT-ffee0c8a8276f2641539083f68304bd9.png";